import DOMPurify from "dompurify";

export const SanitizedHTML = ({ s }: { s: string | undefined }) => {
  return <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(s ? s : "") }} />;
};
